import type { Dispatch } from 'redux'
import { connect } from 'react-redux'
/*
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
*/
import { SigninComponent } from './SigninComponent'
import { fetchSigninPageData, resetSignin } from 'shared/store/signin'
import type { RootState } from 'shared/store/reducers'
import { fetchAvailableFeatures } from 'shared/store/features'

const mapStateToProps = (state: RootState) => state.signinPageState
const mapDispatchToProps = (d: Dispatch<any>) => ({
    // sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    fetchPageData: () => d(fetchSigninPageData()),
    reset: () => d(resetSignin()),
    fetchAvailableFeatures: () => d(fetchAvailableFeatures())
})

const Signin = connect(mapStateToProps, mapDispatchToProps)(SigninComponent)

export { Signin }
